import { z } from 'zod';
export const stEvalValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        subjective: z
            .object({
            patientReporting: z.string().optional(),
            progressExpectation: z.string().optional(),
            barriersToProgress: z.string().optional(),
            commentsOnProgress: z.string().optional(),
            cognitiveExercises: z.string().optional(),
            bp: z.object({
                rest: z.object({
                    systolic: z.string().optional(),
                    diastolic: z.string().optional(),
                }),
                activity: z.object({
                    systolic: z.string().optional(),
                    diastolic: z.string().optional(),
                }),
            }),
            sp02: z.object({
                rest: z.string().optional(),
                activity: z.string().optional(),
            }),
            heartRate: z.object({
                rest: z.string().optional(),
                activity: z.string().optional(),
            }),
            respiration: z.object({
                rest: z.string().optional(),
                activity: z.string().optional(),
            }),
        })
            .optional(),
        mentalStatus: z
            .object({
            status: z.string().optional(),
            orientedToPerson: z.string().optional(),
            orientedToPlace: z.string().optional(),
            orientedToPurpose: z.string().optional(),
            orientedToTime: z.string().optional(),
            conditions: z.array(z.string()).optional(),
            aggravatingFactor: z.string().optional(),
        })
            .optional(),
        dietStatus: z.string().optional(),
        followCommands: z.array(z.string()).optional(),
        height: z.string().optional(),
        weight: z.string().optional(),
        impairments: z
            .object({
            affecting: z.array(z.string()).optional(),
            affectingFunctionalAbility: z.string().optional(),
        })
            .optional(),
        hep: z
            .object({
            progression: z.string().optional(),
            reviewed: z.string().optional(),
            advanced: z.string().optional(),
            modified: z.string().optional(),
            patientAction: z.array(z.string()).optional(),
            ptActionSpecify: z.string().optional(),
            understanding: z.string().optional(),
            properTechnique: z.array(z.string()).optional(),
        })
            .optional(),
        stcgEducation: z
            .object({
            behaviors: z.array(z.string()).optional(),
            dischargePlanning: z.string().optional(),
            learningStatus: z.string().optional(),
            other: z.string().optional(),
        })
            .optional(),
        assessmentExpressNeeds: z
            .object({
            verbal: z.object({
                needs: z.string().optional(),
                accuracy: z.string().optional(),
            }),
            nonVerbal: z.array(z.string()).optional(),
            writing: z.object({
                types: z.array(z.string()).optional(),
                accuracy: z.string().optional(),
            }),
        })
            .optional(),
        volume: z.string().optional(),
        articulation: z.string().optional(),
        pitch: z.string().optional(),
        sessionTolerance: z
            .object({
            tolerance: z.array(z.string()).optional(),
            toleranceOther: z.string().nullable().optional(),
        })
            .optional(),
        overallProgress: z
            .object({
            progress: z.array(z.string()).optional(),
            progressOther: z.string().nullable().optional(),
        })
            .optional(),
        reasonForContinuedTherapy: z
            .object({
            reasons: z.array(z.string()).optional(),
            reasonsOther: z.string().nullable().optional(),
        })
            .optional(),
        homeboundReason: z
            .object({
            reasons: z.array(z.string()).optional(),
            reasonsOther: z.string().nullable().optional(),
        })
            .optional(),
        coordination: z
            .object({
            nameTitle: z.string().optional(),
            reviewed: z.string().optional(),
        })
            .optional(),
        misc: z
            .object({
            nextAppointment: z.string().optional(),
            notes: z.array(z.string()).optional(),
            notesOther: z.string().nullable().optional(),
        })
            .optional(),
        planForNextVisit: z
            .object({
            plans: z.array(z.string()).optional(),
            plansOther: z.string().nullable().optional(),
        })
            .optional(),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
